import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'

import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import LinearProgress from '@material-ui/core/LinearProgress'

import { connect } from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import { loadSiteApplications } from '../actions/siteapplications'

import { Box } from 'swx-atomic-component-lib'
import i18n from '../i18n'

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  table: {
  }
})

class SiteApplicationsList extends Component {
  state = {
    redirectTo: null,
    anchorEl: null,
    isProcessing: false,
    siteApplications: []
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  componentDidMount = () => {
    this.setState({ isProcessing: true })
    this.props.loadSiteApplications().then(() => {
      this.setState({ isProcessing: false, siteApplications: this.props.siteApplication.items })
    })
  }

  onMoreVertClick = (e) => {
    this.setState({ anchorEl: e.currentTarget })
  }

  handleClose = (e) => {
    this.setState({ anchorEl: null })
  }

  handleNewAppButtonClick = (e) => {
    this.setState({ redirectTo: '/applications/create' })
  }

  onEditClick = (id, e) => {
    this.setState({ redirectTo: `/applications/${id}` })
  }

  onDeleteClick = (e) => {

  }

  render () {
    const { anchorEl } = this.state

    if (this.state.redirectTo) {
      return <Redirect to={this.state.redirectTo} />
    }

    return (
      <Box w='100%' display='flex' justifyContent='center'>
        <Box w='75%'>
          <Typography variant='h5'>{i18n.application.list.header}</Typography>
          <Button color='primary' onClick={this.handleNewAppButtonClick}>
            {i18n.application.list.createButton}
          </Button>

          <Paper className={this.classes.root}>
            {this.state.isProcessing && <LinearProgress variant='indeterminate' />}
            <Table className={this.classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>{i18n.application.list.table.column.name}</TableCell>
                  <TableCell>{i18n.application.list.table.column.clientId}</TableCell>
                  <Hidden smDown><TableCell>{i18n.application.list.table.column.baseUrl}</TableCell></Hidden>
                  <Hidden smDown><TableCell>{i18n.application.list.table.column.description}</TableCell></Hidden>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  this.state.siteApplications.length
                    ? (this.state.siteApplications.map(app =>
                      <TableRow key={app.id}>
                        <TableCell onClick={(e) => this.onEditClick(app.id, e)}>{app.name}</TableCell>
                        <TableCell onClick={(e) => this.onEditClick(app.id, e)}>{app.client_id}</TableCell>
                        <Hidden smDown><TableCell onClick={(e) => this.onEditClick(app.id, e)}>{app.base_url}</TableCell></Hidden>
                        <Hidden smDown><TableCell onClick={(e) => this.onEditClick(app.id, e)}>{app.description}</TableCell></Hidden>
                        <TableCell>
                          <IconButton aria-label='More Options' id={app.client_id} key={app.client_id} onClick={(e) => this.onMoreVertClick(e)}>
                            <MoreVertIcon />
                          </IconButton>
                          <Menu key={app.id} id={app.id} anchorEl={anchorEl} open={Boolean(anchorEl && (anchorEl.id === app.client_id))} onClose={this.handleClose}>
                            <MenuItem onClick={(e) => this.onEditClick(app.id, e)}>{i18n.common.button.edit}</MenuItem>
                            <MenuItem onClick={(e) => this.onDeleteClick(app.id.e)}>{i18n.common.button.delete}</MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>))
                    : (<TableRow><TableCell /></TableRow>)
                }
              </TableBody>
            </Table>
          </Paper>
        </Box>
      </Box>
    )
  }
}

function mapStateToProps (state) {
  return {
    siteApplication: state.siteApplication
  }
}

const SiteApplicationsListComponent = withStyles(styles)(SiteApplicationsList)

export default connect(mapStateToProps, { loadSiteApplications })(SiteApplicationsListComponent)
